export default "__VITE_ASSET__731a225b__"